/* eslint-disable */

import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { get } from 'lodash';
import slugify from 'slugify';
import Layout from '~components/Layout';
import Topper from '~components/base/Topper';
import BodyElement from '~components/body/BodyElement';
import ArchieElement from '~components/body/ArchieElement';
import Byline from '~components/base/Bylines';
import SeoSocial from '~components/base/SeoSocial';
import useBusiness from '~lib/useBusiness';
import GlobalStyles from '../styles/GlobalStyles';

import SectionContainer from '~components/graphics/sectioncontainer';
import HeadlineImage from '~components/base/headlineimage';

import ComboElement from '~components/body/ComboElement';

export const pageQuery = graphql`
    query{
        site {
          pathPrefix
          siteMetadata {
            title
            sectionName
            projectName
          }
        }
        story: arcStory(storyId: {eq: "PUOSM3TAGBHXHAGOBSJW73RGXQ"}) {
            headlines {
                basic
            }
            subheadlines {
                basic
            }
            # credits {
            #     name
            #     url
            # }
            bodyElements {
              _id
              type
              subtype
              alignment
              content
              archieJson
              url
              srcSet
              caption
              subtype
              # localImage {
              #     childImageSharp {
              #         gatsbyImageData(width: 2000)
              #     }
              # }
              # images {
              #   caption
              #   _id
              #   localImage {
              #     childImageSharp {
              #       gatsbyImageData(width: 900)
              #     }
              #   }
              # }
              bodyElements {
                _id
                content
              }
              # content_elements {
              #   url
              #   type
              #   caption
              #   _id
              # }
              # description {
              #   basic
              # }
              citation {
                content
              }
            }
            # getting seo social data
            promoImage {
              sizes {
                _1024
              }
            }
            description {
              basic
            }
            # getting teasers information
            relatedLinks {
              headlines {
                basic
              }
              promoImage {
                sizes {
                  _1024
                  _480
                  _640
                  _240
                }
                srcSet
                url
              }
              url
            }
            slug
        }
    }
`;

/* eslint-disable */

const ArticleTemplate = ({
  data: {
    story,
    site: {
      pathPrefix,
      siteMetadata: { sectionName, projectName },
    },
  },
}) => {
  const slugifiedSection = slugify(sectionName, { lower: true });
  const authorNames = get(story, 'credits', [])
    .map((credit) => credit.name)
    .join(', ');

  useBusiness({
    pageName: `${slugifiedSection} | ${get(story, 'headlines.basic')}`,
    environment: process.env.NODE_ENV,
    meterContent: (process.env.NODE_ENV !== 'development'),
    pageId: `apps.${story.slug}`,
    section: slugifiedSection,
    author: authorNames,
    projectName,
  });

  const subhed = get(story, 'subheadlines.basic')
    ? (<h3 className="subheadline miller-n4">{get(story, 'subheadlines.basic')}</h3>)
    : (null);
  const metaUrl = `https://apps.bostonglobe.com${pathPrefix}`;

  // testing for presence of publishDate archie element
  // if it exists, set the pubDateObj to it's value and pass to the Byline component below
  // if it doesn't pass null
  let pubDateObj = null;
  story.bodyElements.forEach((e) => {
    if (e.archieJson) {
      const parsedArchie = JSON.parse(e.archieJson);
      if (parsedArchie.publishDate !== undefined) {
        pubDateObj = parsedArchie;
      }
    }
  });

  //Sectioning Arc content -- looks for "section" in Arc archie
  //PART 1

  //Master array to hold array of content elements for each section
  let sections = []; 
  //Section array to hold content elements
  let tempSection = [];   

  let comboEl = [];
  let comboInProgress = false;
  let comboType;

  //Loop through content
  story.bodyElements.map((element) => {

    //Check if archie element. If not store element in temporary array of elements
    if (element.archieJson){
        
      //turn element's archieml data into a json
      let archieCopy = element.archieJson
      let archieObj = JSON.parse(archieCopy);

      //if this archie element represents a new section, dump temporary array containing previous elements into the master array and clear it for the next section
      //Otherwise, just store it in temporary array as an element
      if (archieObj.section){
        sections.push(tempSection)
        tempSection = [];
      }
      //add section info to fresh array
      tempSection.push(element)
    }else{
      tempSection.push(element)
    }
  });

  return (
    <Layout>
      <SeoSocial
        url={metaUrl}
        description={get(story, 'description.basic')}
        title={get(story, 'headlines.basic')}
        imageUrl={get(story, 'promoImage.sizes._1024')}
      />
      <GlobalStyles />
      <Topper>
        {subhed}
      </Topper>
      <main>
        <HeadlineImage />

        {

          //Sectioning Arc content
          //PART 2

          //Loop over master array of sections
          sections.map((secs, index) => {

            //Create parent array for content
            let content = []

            //Give an id. Default is index
            let secId = "section-"+index;

            let secTitle;


            //loop over content elements for the array, and format accordingly (body vs archie)
            secs.map((el) => {
              if (el.archieJson) {


                //parse and format
                let archieCopy = el.archieJson
                let archieObj = JSON.parse(archieCopy);

                //Give section an id and title based on section Arc element

                //If there is an id field in the archie object, make this the id instead of the default
                if ((archieObj.section)&&(archieObj.type)){
                  secId = archieObj.type;
                  
                }

                if (archieObj.section){
                  secTitle = archieObj.section;
                }


                //if it's a special combo element, push into temporary combo array
                //Otherwise format and push to content
                if (archieObj.special_format){
                  comboType = archieObj.special_format
                  comboEl.push(el)
                  comboInProgress = true;
                }else{
                  content.push(
                    <ArchieElement
                      data={el}
                      key={el._id}
                      relatedLinks={get(story, 'relatedLinks')}
                    />
                  )
                }
                
              }else{
                if (comboInProgress){ //THIS assumes there is one archie and one body element and pushes to content immediately once it finds the body element
                  comboEl.push(el)

                  //Format with comboElement component
                  content.push(
                    <ComboElement
                      data={comboEl}
                      type={comboType}
                      key={comboEl[0]._id}
                    />
                  )

                  //reset
                  comboType = ''
                  comboInProgress = false;
                  comboEl = [];

                }else{
                  content.push(
                    <BodyElement
                      data={el}
                      key={el._id}
                    />
                  )
                }
                
              }
            })
            //returning the content:

            //If it's the last section, just return it as a div, otherwise return it as a section
            //the last section is the closer that lets us know to end the last section
            if(index == sections.length){
              return(
                <div>
                  {content}
                </div>
              )
              
            }else{
              return(
                <SectionContainer
                  id={secId}
                  content={content}
                  title={secTitle}
                />
              )
            }
            
          })
        }
      </main>
    </Layout>
  );
};

ArticleTemplate.propTypes = {
  data: PropTypes.shape({
    story: PropTypes.shape({
      bodyElements: PropTypes.arrayOf(
        PropTypes.shape({
          archieJson: PropTypes.string,
        }),
      ),
      slug: PropTypes.string,
    }),
    site: PropTypes.shape({
      pathPrefix: PropTypes.string.isRequired,
      siteMetadata: PropTypes.shape({
        title: PropTypes.string.isRequired,
        sectionName: PropTypes.string.isRequired,
        projectName: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  pageContext: PropTypes.shape({
    storyId: PropTypes.string,
  }).isRequired,
};

export default ArticleTemplate;